import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import XLSX from 'xlsx'
import accounting from 'accounting';
import {Table, Button} from 'semantic-ui-react'

class MovingAverageCost extends Component {
    dataToExcel = () => {
        const fn = 'moving_average_evaluation.xlsx';
        let elt = document.getElementById('dls-data-table');
        let wb = XLSX.utils.table_to_book(elt, {sheet: "MovingAverage"});
        return XLSX.writeFile(wb, fn);
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12" style={{marginBottom: '3px'}}>
                    <div style={{float:'right'}}>
                        <Button color='purple' size='mini' onClick={() => {this.dataToExcel()}}>Excel</Button>
                    </div>
                </div>
                <div className="col-md-12"  style={{maxHeight: '575px', overflowY: 'scroll', height: '575px', alignContent:'top'}}>
                <Table compact celled id='dls-data-table'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>SKU</Table.HeaderCell>
                            <Table.HeaderCell>Invoice #</Table.HeaderCell>
                            <Table.HeaderCell>Invoice Date</Table.HeaderCell>
                            <Table.HeaderCell>Quantity Purchased</Table.HeaderCell>
                            <Table.HeaderCell>Unit Cost</Table.HeaderCell>
                            <Table.HeaderCell>Line Total</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.data.map((s,i) => {
                            return (
                                <Table.Row key={i}>
                                    <Table.Cell>{s.SKU}</Table.Cell>
                                    <Table.Cell>{s.InvoiceNumber}</Table.Cell>
                                    <Table.Cell>{s.InvoiceDate}</Table.Cell>
                                    <Table.Cell>{s.QuantityPurchased}</Table.Cell>
                                    <Table.Cell>{s.Cost}</Table.Cell>
                                    <Table.Cell>{accounting.formatNumber(s.Cost * s.QuantityPurchased,2)}</Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
                </div>
            </div>
        )
    }
}

MovingAverageCost.propTypes = {
    data: PropTypes.array.isRequired
};

export default MovingAverageCost


// WEBPACK FOOTER //
// ./src/components/reports/components/moving_average_cost.js